var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.14999 3.33333V3.93333H9.35V3.33333H8.14999ZM3.48333 3.33333V3.93333H4.68333V3.33333H3.48333ZM10.4833 3.91666V13.8333H11.6833V3.91666H10.4833ZM10.4833 13.8333C10.4833 14.1445 10.2279 14.4 9.91668 14.4V15.6C10.8906 15.6 11.6833 14.8073 11.6833 13.8333H10.4833ZM9.91668 14.4H2.91668V15.6H9.91668V14.4ZM2.91668 14.4C2.60548 14.4 2.35002 14.1445 2.35002 13.8333H1.15002C1.15002 14.8073 1.94273 15.6 2.91668 15.6V14.4ZM2.35002 13.8333V3.91666H1.15002V13.8333H2.35002ZM3.48334 5.08334V13.25H4.68334V5.08334H3.48334ZM5.81669 5.08334V13.25H7.01669V5.08334H5.81669ZM8.15 5.08334V13.25H9.35V5.08334H8.15ZM0 3.93334H12.8333V2.73334H0V3.93334ZM9.35 3.33333V2.16211H8.14999V3.33333H9.35ZM9.35 2.16211C9.35 1.18816 8.56184 0.4 7.58789 0.4V1.6C7.89909 1.6 8.14999 1.8509 8.14999 2.16211H9.35ZM7.58789 0.4H5.24544V1.6H7.58789V0.4ZM5.24544 0.4C4.27149 0.4 3.48333 1.18816 3.48333 2.16211H4.68333C4.68333 1.8509 4.93423 1.6 5.24544 1.6V0.4ZM3.48333 2.16211V3.33333H4.68333V2.16211H3.48333Z",
    fill: "#FF5151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.013f7f41ddc66dc4fb7e0e9dd642b03b.svg";
export { ForwardRef as ReactComponent };